import Component from './component';
import refinebarhelper from '../helpers/refinebarHelper';
import utils from '../utils';
var constants = require('../constants');
var isFilterUpdate = false;
var $loaderContainer = $('body');
var showFilterClicked = false;
var isMobile = utils.getCurrentBreakpoint() === 'mobile';
var tealiumEnable = require('int_tealium_sfra/tealiumEnable');

export default class refinebar extends Component {
    constructor(...args) {
        super(...args);
        return this;
    }

    /**
     * Create refinebar modal container
     * @param {string} id
     * @returns
     */
    getModalHtmlElement(id) {
        var htmlString =
        `<div class="modal slide-in refinebar-modal" id="${id}Modal" data-recomtype="" role="dialog"><span class="enter-message sr-only"></span>
            <div class="modal-dialog refinebar-dialog refinebar__modal">
                <!-- Modal content-->
                <div class="modal-content refinebar__modal--content">
                    <div class="refinebar__body">

                    </div>
                </div>
            </div>
        </div>`;

        return htmlString;
    }

    getModalContent(url) {
        let ajaxResponse;
        $.ajax({
            url: url,
            method: 'GET',
            async: false,
            success: function (response) {
                ajaxResponse = response;
            }
        });
        return ajaxResponse;
    }

    openModal() {
        refinebarhelper.onLoad();
        utils.openModal($(`#${this.name}Modal`));
    }

    /**
     * Initialize the modal with data from rendered HTML
     */
    renderRefinebarModal() {
        $('body').append(this.getModalHtmlElement(`${this.name}`));
        const $container = $(`#${this.name}Modal`);

        // get the existing filter markup. we will keep both copy for mobile and modal one for deskop
        const $leftFilter = $('.search-results .ds-left-filter.left-filter');

        // update modal with the same markup
        $('.refinebar__body', $container).empty().html(
            $('<div class="ds-left-filter left-filter">').append($leftFilter.html())
        );

        $leftFilter.remove();
    }

    /**
     * Get active refinement container
     * @returns active refinement container [toprefinement | selectedRefinement]
     */
    getRefinementContainerSelector() {
        const isRefinementSelected = $('.selected-refinements').find('.selected-filter-value:visible').length;
        return isRefinementSelected ? '.selected-refinements' : '.top-refinements';
    }

    /**
     * make the container sticky by adding class
     * @param {jQuery} $container
     */
    makeContainerSticky($container) {
        const refineBarContainerSelector = this.getRefinementContainerSelector();
        $container.css('min-height', $container.outerHeight());
        $(refineBarContainerSelector).addClass('sticky-filter-bar');
    }

    /**
     * Make the container non sticky
     * @param {jQuery} $container
     */
    makeContainerNonSticky($container) {
        $container.css('min-height', '');
        $('.filter-bar').removeClass('sticky-filter-bar');
    }

    /**
     * function which checks if refinebar is within the sticky active area and toggle it
     */
    positionRefinebar($container) {
        if (utils.getCurrentBreakpoint === 'mobile') return;
        var searchResult = $('.ds-search-results.search-results')[0].getBoundingClientRect();
        const refineBarContainerSelector = this.getRefinementContainerSelector();
        const refineBarContainerHeight = $(refineBarContainerSelector).outerHeight();
                // when search result container bottom is at the top
        if (searchResult.bottom < 0) {
            this.makeContainerNonSticky($container);
                // when the bottom is visible in page and top is still not meaning scrolling down from top
        } else if (searchResult.bottom > refineBarContainerHeight && searchResult.top < 0) {
            this.makeContainerSticky($container);
        }
    }

    /**
     * Main function which initialize the sticky behaviour of refinebar
     */
    enableStickyFilter() {
        if (isMobile) return;
        const $refinebar = $('.filtered-list-short');

        let observerOptions = {
            root: null,
            rootMargin: '0px 0px 0px 0px',
            thresholds: 1
        };

        let observer;

        // this function get called over and over to reintialize the intersection observer based on which direction
        // or current state of the filter such as top refinement or selected refinement existing
        const startObserving = () => {
            if (isMobile) return;
            const isNavHidden = $('body').hasClass('nav-hidden');
            const navbarHeight = $('.js-globalnav-header').outerHeight();
            const refinebarElm = document.querySelector('.filtered-list-short');
            const isRefinementSelected = $('.selected-refinements').find('.selected-filter-value:visible').length;

            // changes these values if they change in css
            const searchResultTopMargin = 28;
            const refinebarBottomMargin = 12;

			// define active area for sticky behavior when tall content is present
			const refinebarActiveArea = 100;

            // // this offset will Be used when checking the inview to propetly make the selected refinement ar sticky
            let refinebarheight = $refinebar.outerHeight();
            if (isRefinementSelected) {
                const topRefinementHeight = $('.top-refinements').outerHeight() || 0;
                refinebarheight -= topRefinementHeight;
            }

            // this block determines how how much margin to add and should intersept on entry or exit of the container
            const topOffset = isNavHidden ? searchResultTopMargin : (navbarHeight + (refinebarheight - refinebarBottomMargin)) * -1;
            const thresholds = isNavHidden ? [1] : [0];
            observerOptions.rootMargin = `${topOffset}px 0px 0px 0px`;
            observerOptions.thresholds = thresholds;

            // unobserve any existing observers before setting new
            try {
                if (observer) observer.unobserve(refinebarElm);
            } catch (error) {}

			observer = new IntersectionObserver((entries) => {
				const { top } = entries[0].target.getBoundingClientRect();
                if (!entries[0].isIntersecting && top < refinebarActiveArea) {
					this.makeContainerSticky($refinebar);
    			} else {
    				this.makeContainerNonSticky($refinebar);
    			}
    		}, observerOptions);

            observer.observe(refinebarElm);
        };

        $(window).on('scroll', () => this.positionRefinebar($refinebar));
        $('body').on(constants.events.NAV_UPDATED, startObserving);
        $(document).on(constants.events.SEARCH_FILTER_CHANGE, startObserving);
        startObserving();
    }

    enable() {
        // this creates the desktop version of the refinebar which works larger breakpoints
        if (!isMobile) this.renderRefinebarModal();

        // click binding on modal button
        $(document).on('click', '.refinebar .filter-value, .selected-filter-bar .filter-value', (e) => {
            e.preventDefault();
            e.stopPropagation();
            const topRefinement = $(e.currentTarget).attr('data-refinement');
            this.openModal();
            let $modalElem = $('#refinebarModal .refinebar__modal--content');
            let $element;
            let offsetTop;
            if (typeof topRefinement !== 'undefined') {
                refinebarhelper.updateAccordian([topRefinement]);
                $element = $(`#refinebarModal #${topRefinement}-drawer`);
                // Adjust the scroll position with offset without all filter pill
                if ($element.length) {
                    let elementTop = $element.length ? $element.offset().top : 0;
                    let modalTop = $modalElem.offset().top;
                    let currentScroll = $modalElem.scrollTop();
                    offsetTop = elementTop - modalTop + currentScroll - 87;
                } else {
                    offsetTop = 0;
                }
                
                tealiumEnable.getAnalyticsData('updateFilterPanelEvent', topRefinement);
            } else {
                // Adjust the scroll position with offset for all filter pill
                $element = $('.drawer-group').find('.enable-drawer').first();
                offsetTop = 0;
                tealiumEnable.getAnalyticsData('updateFilterPanelEvent', 'all filters');
            }
            if ($element.length) {
                //Added length check before calling scrollIntoView on $element
                $element[0].scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'nearest'
                });
            }
            setTimeout(function () {
                $modalElem.scrollTop(offsetTop);
                refinebarhelper.updateFilterAccordionState();
            }, 300);
        });

        $(this.$el).on('keyup', (event) => {
            if (event.key === 'Enter' && this.el.dataset.stayopen) {
                $(this.$el).trigger('click');
            }
        });

        $('body').on('click', '.refinementValue_checkbox, .refinementValue_color, .refinementValue_price, .refinementValue_size, .refinementValue_Categories, .refinements li button, #refinebarModal button.reset, .ds-filter-footer .ds-action .reset, .swatch-filter button, .selected-filter-value button, .filter-bar-clearAll button', function (e) {
            e.preventDefault();
            e.stopPropagation();
            refinebarhelper.setFilterAccordionState();
            // refinebarhelper.setLoaderContainer();

            // Adobe Analytics - Tealium
            var selectableFilters = ['neck', 'size', 'waist', 'length'];
            var $filterElem = $(this);
            var $productGrid = $('.search-results');
            var selectedFilter = $filterElem.find('.filter-item').data('displayvalue');
            var filterClass = $filterElem.closest('.enable-drawer').data('refinementname') || $filterElem.data('refinementtype');
            var sortingRule = $('.sort-menu-item.selected').attr('data-id');
            $('.product-grid .productTileShow').addClass('producttile-transparency');
            $loaderContainer.spinner().start(true);
            var filterButtonUrl = $filterElem.data('href') ? $filterElem.data('href') : $filterElem.attr('href');
            if ($filterElem.parent().hasClass('filter-bar-clearAll') || $(this).hasClass('reset')) {
                window.sessionStorage.removeItem('selectedPriceFilters');
            }
            var selectedPriceFilters = [];

            if (filterClass === 'price') {
                selectedPriceFilters = window.sessionStorage.getItem('selectedPriceFilters') ? JSON.parse(window.sessionStorage.getItem('selectedPriceFilters')) : [];
                var id = $filterElem.attr('id');
                if (selectedPriceFilters.indexOf(id) === -1) {
                    var currentpricerange = $filterElem.data('currentpricerange');
                    filterButtonUrl = refinebarhelper.updatePriceRange(filterButtonUrl, currentpricerange[0], currentpricerange[1]);
                    selectedPriceFilters.push($filterElem.attr('id'));
                    window.sessionStorage.setItem('selectedPriceFilters', JSON.stringify(selectedPriceFilters));
                } else {
                    $filterElem.children('input').attr('checked', false);
                    $('.filter-bar.selected-refinements li.' + id).addClass('d-none');
                    filterButtonUrl = refinebarhelper.updatePriceFilters(selectedPriceFilters, filterButtonUrl, selectedPriceFilters.indexOf(id));
                }
            }

            if ($(this).parent().hasClass('priceBar')) {
                $(this).parent().addClass('d-none');
                selectedPriceFilters = window.sessionStorage.getItem('selectedPriceFilters') ? JSON.parse(window.sessionStorage.getItem('selectedPriceFilters')) : [];
                var idToRemove = $(this).parent()[0].classList[2];
                var index = selectedPriceFilters.indexOf(idToRemove);
                $('#' + idToRemove).children('input').attr('checked', false);
                filterButtonUrl = refinebarhelper.updatePriceFilters(selectedPriceFilters, filterButtonUrl, index);
            }

            var newURL = new URL(filterButtonUrl, location.origin);
            newURL.searchParams.set('srule', sortingRule);
            filterButtonUrl = newURL.pathname + newURL.search;
            $filterElem.trigger('search:filter', e);
            refinebarhelper.setFilterAccordionState();

            // if filter is part of any selectable and then toggle the class
            if (selectableFilters.indexOf(filterClass) >= 0) {
                $filterElem.toggleClass('size--selectable size--selected');
            }
            refinebarhelper.updateCarouselState(filterButtonUrl);
            $.ajax({
                url: filterButtonUrl,
                data: {
                    page: $('.grid-footer').data('page-number'),
                    isRefinement: true
                },
                method: 'GET',
                success: function (response) {
                    refinebarhelper.parseResults(response);
                    if (!!filterClass && !!selectedFilter) {
                        var selectedfilters = $('.selectedFiltersAnalytics').val();
                        let currentFilter = filterClass + ':' + selectedFilter.toString().toLowerCase();
                        if (selectedfilters.includes(currentFilter)) {
                            tealiumEnable.getAnalyticsData('applyFilterEvent', selectedFilter, filterClass, selectedfilters);
                        }
                    }
                    // TODO : this logic does not belong to refinebar component and should be make as an event which category carousel can listen to
                    refinebarhelper.updateFilterAccordionState();
                    setTimeout(() => {
                        $loaderContainer.spinner().stop();
                    }, 300);
                    var pageUrl = new URL(window.location);
                    var tempUrl = new URL(pageUrl.origin + filterButtonUrl);
                    tempUrl.searchParams.delete('cgid');
                    if ($filterElem.parent().hasClass('filter-bar-clearAll') || $filterElem.hasClass('clear-all') || $filterElem.hasClass('reset')) {
                        var clearlinkhref = $filterElem.data('clearlinkhref');
                        pageUrl.href = clearlinkhref;
                    }
                    pageUrl.search = tempUrl.search;
                    if (filterClass === 'color') {
                        pageUrl.href = tempUrl.href;
                    }
                    window.history.replaceState(null, '', pageUrl);
                    refinebarhelper.handleRefinementChange();
                    $(document).trigger(constants.events.SEARCH_FILTER_CHANGE);
                    $('.product-grid .productTileShow').removeClass('producttile-transparency');
                    isFilterUpdate = true;
                    refinebarhelper.handlePriceFilter();
                    refinebarhelper.initializePageDesignerScript(response);
                    refinebarhelper.genderPillPosition(tempUrl);
                    refinebarhelper.setDefaultSort();
                    setTimeout(() => PVH.mountAllComponents('quickView'), 500);
                },
                error: function () {
                    $filterElem.toggleClass('size--selectable size--selected');
                    $loaderContainer.spinner().stop();
                }
            });
        });

        $('body').on('click', '#clearSelectedFilter, #clearSelectedPriceFilter', function (e) {
            e.preventDefault();
            e.stopPropagation();
            refinebarhelper.setLoaderContainer();

            var targetSelector = $(this).attr('id');
            var $productGrid = $('.search-results');
            var selectedContainerId = $(e.target).data('target');
            var sortingRule = $('.sort-menu-item.selected').attr('data-id');
            var clearFilterUrl = $(e.target).data('href');
            var clearlinkhref = $(e.target).data('clearlinkhref');
            var filterClass = $(this).closest('.enable-drawer').data('refinementname');
            clearFilterUrl = clearFilterUrl.indexOf('srule=') > -1 ? `${clearFilterUrl}` : `${clearFilterUrl}&srule=${sortingRule}`;
            $loaderContainer.spinner().start(true);
            $('.product-grid .productTileShow').addClass('producttile-transparency');
            refinebarhelper.setFilterAccordionState();
            refinebarhelper.updateCarouselState(clearFilterUrl);
            $.ajax({
                url: clearFilterUrl,
                data: {
                    page: $('.grid-footer').data('page-number')
                },
                method: 'GET',
                success: function (response) {
                    refinebarhelper.parseResults(response);
                    refinebarhelper.updateFilterAccordionState();

                    if (targetSelector != 'clearSelectedPriceFilter') {
                        refinebarhelper.handlePriceFilter();
                    }
                    $('#' + selectedContainerId).parents('.enable-drawer').find('.enable-drawer__button').trigger('click');
                    var pageUrl = new URL(window.location);
                    var tempUrl = new URL(pageUrl.origin + clearFilterUrl);
                    if (selectedContainerId.indexOf('price') >= 0) {
                        window.sessionStorage.removeItem('selectedPriceFilters');
                    } else {
                        var selectedPriceFilters = window.sessionStorage.getItem('selectedPriceFilters') ? JSON.parse(window.sessionStorage.getItem('selectedPriceFilters')) : [];
                        for (var i = 0; i < selectedPriceFilters.length; i++) {
                            var id = selectedPriceFilters[i];
                            $('.filter-bar.selected-refinements li.' + id).removeClass('d-none');
                            $('#' + id).children('input').attr('checked', 'checked');
                        }
                    }
                    if (filterClass === 'color') {
                        pageUrl.href = clearlinkhref;
                    }
                    tempUrl.searchParams.delete('cgid');
                    pageUrl.search = tempUrl.search;
                    window.history.replaceState(null, '', pageUrl);
                    $loaderContainer.spinner().stop();
                    refinebarhelper.handleRefinementChange();
                    $('.product-grid .productTileShow').removeClass('producttile-transparency');
                    $(document).trigger(constants.events.SEARCH_FILTER_CHANGE);
                    refinebarhelper.initializePageDesignerScript(response);
                    refinebarhelper.setDefaultSort();
                },
                error: function () {
                    $loaderContainer.spinner().stop();
                }
            });
        });

        $('body').on('click', '#refinebarModal button.close, .modal-background', function () {
            $('#refinebarModal, .modal-background').hide();
            $('#refinebarModal').siblings().attr('aria-hidden', false);
            $('#refinebarModal').closest('.row').siblings().attr('aria-hidden', false);
            $('#refinebarModal').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
            $('#refinebarModal').closest('.container.search-results').siblings().attr('aria-hidden', false);
            $('.btn.filter-results').focus();
        });

        $(document).on('click', '.overlay-filters, .filter-close .fa-times', function () {
            refinebarhelper.handleRefinementChange();
            if (isMobile) {
                refinebarhelper.filterClose('.js-search-results', false);
            } else {
                utils.closeModal($('#refinebarModal'));
            }
        });

        $(document).on('click', '.view-filter', function () {
            let searchCloseFilterModal = $(document).find('.search-page-only');
            if (!searchCloseFilterModal.length) {
                refinebarhelper.handleRefinementChange();
            }

            if (searchCloseFilterModal.length && isMobile) {
                if ($(document).find('.searchFilterModalClose').attr('data-searchmodalclose') === 'true') {
                    refinebarhelper.filterClose('body', false);
                } else {
                    refinebarhelper.filterClose('body', true);
                }
            } else {
                if (isMobile) {
                    refinebarhelper.filterClose('.js-search-results', false);
                } else {
                    utils.closeModal($('#refinebarModal'));
                }
            }
        });

        $('.ds-filter-head .icon-utility-close').on('click', function () {
            if (isFilterUpdate) {
                refinebarhelper.filterClose('.js-search-results', false);
            } else {
                refinebarhelper.filterClose('body', true);
            }
        });

        $(document).on('click', '.ds-filter-head .btn-close-wrap', function () {
            let searchCloseFilterModal = $(document).find('.search-page-only');
            // FIXME this if condition is for SRP page only clean up for PLP page
            if (searchCloseFilterModal.length) {
                if ($(document).find('.searchFilterModalClose').attr('data-searchmodalclose') === 'true') {
                    refinebarhelper.filterClose('body', false);
                } else {
                    refinebarhelper.filterClose('body', true);
                }
            } else {
                if (isFilterUpdate) {
                    refinebarhelper.filterClose('body', false);
                } else {
                    refinebarhelper.filterClose('body', true);
                }
            }
            if ($('#sort-drawer .accordionHeader .btn').hasClass('collapsed')) {
                $('#sort-drawer').data('sort-default', 'on');
            }
        });

        $('.container').on('click', 'button.filter-results', function () {
            $('.refinement-bar, .modal-background').show();
            $('.refinement-bar').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
            $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
            $('.refinement-bar .close').focus();
        });

        $('.show-filters-btn').on('click', function () {
            refinebarhelper.filterOpen();
            tealiumEnable.getAnalyticsData('showFiltersEvent', showFilterClicked);
            showFilterClicked = true;
        });

        this.enableStickyFilter();
    }
}
